import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { EmailSourceType } from '../../enums/enums'
import { I18nService, LgType } from '../../services/prod/i18n.service'
import { SetColorsService } from '../../services/set-colors.service'
import { AppType } from '../../types/app.type'
import { ISocialContact } from '../../types/common.type'
import { Contacts } from '../../types/producer.type'

@Component({
  selector: 'bmcore-contacts-block',
  templateUrl: './bmcore-contacts-block.component.html',
  styleUrls: ['./bmcore-contacts-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreContactsBlockComponent implements OnInit {
  @Input() appType: AppType

  @Input() socialContacts: ISocialContact[] = []
  @Input() beatmakerName: string
  @Input() beatmakerId: number
  @Input() emailSecret: string
  @Input() sourceType: EmailSourceType

  @Input() BMTVContacts: Contacts

  lg: LgType
  colorSettingsMode = false

  constructor(
    private i18nService: I18nService,
    private setColorsService: SetColorsService
  ) {}

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
    this.getColorSettingsMode()
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
